module.exports = __webpack_public_path__ + "static/pantai-pink-lombok-b0faab5d375ae113995ce857651898b8.png";